import { store } from '../store';

export function AppUser() { 
    return store.getState().session.appUser;
}